import { Reducer } from 'redux'
import FLUX_UPDATEPASS_CONSTANTS from '../constants/updatePass-constants';

export interface PasswordReducerState {
    loading: boolean,
    errorMessage?: string,
    errorStatus?: number,
    wrongPassError: String,
    success: boolean
}

const initialState: PasswordReducerState = {
    loading: false,
    errorMessage: "",
    errorStatus: 0,
    wrongPassError: '',
    success: false
}

export const updatePasswordReducer = (state = initialState, action: any) => {
    let errorMessage = "ERROR"
    switch (action.type) {
        case FLUX_UPDATEPASS_CONSTANTS.UPDATEPASS_BEGIN:
            return {
                loading: true,
                success: false,
                errorMessage: "",
                errorStatus: 0,
            }
        case FLUX_UPDATEPASS_CONSTANTS.UPDATEPASS_SUCCESS:
            return {
                loading: false,
                success: true,
                errorMessage: "",
                errorStatus: 0,

            }
        case FLUX_UPDATEPASS_CONSTANTS.UPDATEPASS_FAILED:
            errorMessage = "ERROR";
            if (action.error && action.error.data) {
                errorMessage = action.error.data.errors.message
                    ? action.error.data.errors.message
                    : action.error.data.errors;
            }
            return {
                loading: false,
                success: false,
                errorMessage: errorMessage,
                errorStatus: action.error ? action.error.status : 0
            }

        case FLUX_UPDATEPASS_CONSTANTS.UPDATEPASS_CLEAR:
            return {
                loading: false,
                success: false,
                errorMessage: "",
                errorStatus: "",
            }
        default:
            return state


    }
}